module.exports = __webpack_public_path__ + "245f94b18608398bb2c34bb31641ce8f.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_line_stacked_bar_1month.png
// module id = 882
// module chunks = 7